export function registerPageView(path) {
    if (window.ga && typeof window.ga === 'function') {
        window.ga('set', 'page', path);
        window.ga('send', 'pageview');
    }
}
